export interface GetAudiencesRequestType{
    ProfileId: number;
}

export class GetAudiencesRequest{
    ProfileId: number = 0;
}